import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { IconName, ILink, IconComponent, ButtonComponent, LinkDirective } from '@sirius/common';

@Component({
    selector: 'commerce-file-download-card',
    templateUrl: './file-download-card.component.html',
    styleUrls: ['./file-download-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [IconComponent, ButtonComponent, LinkDirective]
})
export class FileDownloadCardComponent {
    @Input()
    buttonText!: string;

    @Input()
    siriusIconName!: IconName;

    @Input()
    fileTitle?: string;

    @Input()
    fileDescription?: string;

    @Input()
    link!: ILink;
}
